// removed by extract-text-webpack-plugin
module.exports = {"Switch":"_2XvE9","Slider":"_3Sg-z","ImageContainer":"_2Q7pY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ThemeSwitch/ThemeSlidingSwitch/ThemeSlidingSwitch.scss
// module id = 676
// module chunks = 0